module.exports = __webpack_public_path__ + "static/media/bg-inicio.3b9d3680.svg";